module.exports = __webpack_public_path__ + "img/焦云立.78ecc474.jpg";